import { useState, useEffect } from "react";

export function useActiveElement() {
    const [activeElement, setActiveElement] = useState(
        () => document.activeElement
    );

    useEffect(() => {
        const handleFocusChange = () => {
            setActiveElement(document.activeElement);
        };
        document.addEventListener("focusin", handleFocusChange);
        document.addEventListener("focusout", handleFocusChange);

        handleFocusChange();

        return () => {
            document.removeEventListener("focusin", handleFocusChange);
            document.removeEventListener("focusout", handleFocusChange);
        };
    }, []);

    return activeElement;
}
